import { Injectable, signal, WritableSignal } from '@angular/core';
import { Bewerber } from '../models/bewerber.model';
import { VerificationResponseDto } from '../adapter/dto/verification-response.dto';
import { ContactData } from '../adapter/dto/contact-data.dto';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  // Private writable signals
  private readonly _token: WritableSignal<string | null> = signal<string | null>(null);
  private readonly _birthdate: WritableSignal<Date | null> = signal<Date | null>(null);
  private readonly _verificationResponse: WritableSignal<VerificationResponseDto | null> = signal<VerificationResponseDto | null>(null);
  private readonly _isLoading: WritableSignal<boolean> = signal<boolean>(false);
  private readonly _hasError: WritableSignal<boolean> = signal<boolean>(false);
  private readonly _vpManager: WritableSignal<ContactData | null> = signal<ContactData | null>(null);
  private readonly _aweManager: WritableSignal<ContactData | null> = signal<ContactData | null>(null);

  public getIsLoading(): boolean {
    return this._isLoading();
  }

  public getHasError(): boolean {
    return this._hasError();
  }

  public getToken(): string | null {
    return this._token();
  }

  public hasValidTokenAndBirthdate(): boolean {
    return this.getToken() !== null && this.getBirthdate() !== null;
  }

  public getVerificationResponse(): VerificationResponseDto | null {
    return this._verificationResponse();
  }

  public getAnmeldeschluss(): string | null {
    return this._verificationResponse()?.anmeldeschluss ?? null;
  }

  public getBewerber(): Bewerber | null {
    return this._verificationResponse()?.bewerber ?? null;
  }

  public getAweManager(): ContactData | null {
    return this._aweManager();
  }

  public getVpManager(): ContactData | null {
    return this._vpManager();
  }

  public getBirthdate(): Date | null {
    return this._birthdate();
  }

  public setIsLoading(value: boolean): void {
    this._isLoading.set(value);
  }

  public setHasError(value: boolean): void {
    this._hasError.set(value);
  }

  public setToken(value: string | null): void {
    this._token.set(value);
  }

  public setVerificationResponse(value: VerificationResponseDto | null): void {
    this._verificationResponse.set(value);
  }

  public datenschutzeinwilligungAkzeptiert(): void {
    const current: VerificationResponseDto | null = this.getVerificationResponse();
    if (current === null) {
      return;
    }

    this._verificationResponse.set({ ...current, datenschutzeinwilligung: true });
  }

  public verschwiegenheitsverpflichtungAkzeptiert(): void {
    const current: VerificationResponseDto | null = this.getVerificationResponse();
    if (current === null) {
      return;
    }

    this._verificationResponse.set({ ...current, verschwiegenheitsverpflichtung: true });
  }

  public bewerbungsunterlagenEingereicht(): void {
    const current: VerificationResponseDto | null = this.getVerificationResponse();
    if (current === null) {
      return;
    }

    this._verificationResponse.set({ ...current, bewerbungsunterlagenVorhanden: true });
  }

  public setAweManager(value: ContactData | null): void {
    this._aweManager.set(value);
  }

  public setVpManager(value: ContactData | null): void {
    this._vpManager.set(value);
  }

  public setBirthdate(value: Date | null): void {
    this._birthdate.set(value);
  }
}
